<template>
  <div class="card">
    <div class="card-header">
      <h5 class="card-title">Recent Jobs with Errors</h5>
    </div>
    <div class="card-body">
      <el-table class="table-striped indexed-table-column-width"
                :data="tableData"
                :max-height="tableHeight(400)"
                border
                style="table-layout:fixed; width:100%;">
        <el-table-column
          :width="indexColumnWidth"
          align="center"
          label="#"
          type="index">
        </el-table-column>
        <el-table-column
          label="Job Name"
          min-width="200">
          <template v-slot="props">
            <div class="no-wrap-ellipsis"><a @click.prevent="viewLog(props.row.id)" href="#">{{ props.row.name }}</a></div>
          </template>
        </el-table-column>
        <el-table-column
          label="# Errors"
          min-width="110">
          <template v-slot="props">
            <div class="no-wrap-ellipsis">{{ jobErrorCount(props.row.id) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          class="el-table__fixed"
          fixed="right"
          label="Actions">
          <template v-slot="props">
            <p-button type="success" size="md" icon class="btn-left" title="View/Edit Job">
              <span class="invisible">Job Id: {{ props.row.id }}</span>
              <i class="nc-icon nc-ruler-pencil" @click="handleEditJob(props.row.id)"></i>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="col-sm-12 pagination-info">
        <span class="category">Showing {{total}} entries</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Constants from 'src/utilities/constants'
  import {todayStart, todayEnd, setIndexColumnWidth, getTableHeight} from 'src/utilities/utils'
  import {OK} from 'http-status-codes'
  import _ from 'lodash'

  export default {
    data() {
      return {
        tableData: [],
        errorCount: {},
        constants: Constants
      }
    },
    computed: {
      total() {
        return this.tableData.length
      },
      indexColumnWidth() {
        return setIndexColumnWidth(this.tableData.length)
      }
    },
    methods: {
      jobErrorCount(jobId) {
        return this.errorCount[jobId]
      },
      async viewLog(jobId) {
        this.$eventHub.$emit('show-modal-1', 'View Log', {entityType: 'Job', entityId: jobId}, '80%')
      },
      tableHeight(buffer) {
        return getTableHeight(buffer)
      },
      handleEditJob(jobId) {
        this.$eventHub.$emit('show-modal-1', 'Edit Job', {id: jobId}, '1000px')
      }
    },
    async beforeMount() {
      const logResponse = await this.$store.dispatch('logs/fetchByEntityTypeAndLogLevelAndCreatedAt', {
        entityType: Constants.ENTITIES.JOB,
        level: Constants.LOG_LEVELS.ERROR,
        createdAt: [
          todayStart(),
          todayEnd()
        ]
      })

      if (OK === logResponse.status) {
        const jobIds = _.map(logResponse.data, 'entityId')
        if (jobIds.length > 0) {
          const jobResponse = await this.$store.dispatch('fetchByIds', {endpoint: 'jobs', ids: _.uniq(jobIds)})

          if (OK === jobResponse.status) {
            this.errorCount = _.countBy(jobIds)
            this.tableData = jobResponse.data
          }
        }
      }
    }
  }
</script>

<style scoped>
  .no-wrap-ellipsis {
    width: 0;
    min-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
